import AnalyticsData from "../../model/AnalyticsData";
import AnalyticsTitle from "../AnalyticsTitle";
import { tt } from "../../../../utils/i18n/i18n";
import PieGraph from "../graphs/PieGraph";
import { buildDisplayNameForSource } from "../../../../utils/helpers/UTMParametersUtils";
import ParticipationChart from "../graphs/ParticipationChart";
import React from "react";
import TitleAndTwoColumns from "../layout/TitleAndTwoColumns";

interface Props {
  data: AnalyticsData | undefined;
}

export default function (props: Props) {
  const totalPlayers = props.data?.nActivePlayers || 0;

  if (!totalPlayers) {
    return null;
  }

  return (
    <TitleAndTwoColumns
      title={
        <AnalyticsTitle
          title={tt("analytics_total_players_title", {
            totalPlayers,
            nGamePlayed: props.data?.nGamePlayed || 0
          })}
        />
      }
      left={
        <PieGraph
          title={tt("analytics_player_sources")}
          distribution={props.data?.distributionOfActivePlayersBySource}
          getDisplayNameForLabel={buildDisplayNameForSource}
          groupSourcesByLabel={true}
          largeTotal={true}
        />
      }
      right={
        <ParticipationChart
          distribution={props.data?.distributionOfGameAndMLParticipation}
        />
      }
    />
  );
}
